import { render, staticRenderFns } from "./send-resupply.modal.vue?vue&type=template&id=b30af796&scoped=true&"
import script from "./send-resupply.modal.vue?vue&type=script&lang=js&"
export * from "./send-resupply.modal.vue?vue&type=script&lang=js&"
import style0 from "./send-resupply.modal.vue?vue&type=style&index=0&id=b30af796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30af796",
  null
  
)

export default component.exports